import { Button, Upload } from "antd";
// import ImgCrop from "antd-img-crop";
import { useContext, useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   addGalleryImage1,
//   addGalleryImage2,
//   addGalleryImage3,
//   addGalleryImage4,
//   addGalleryImage5,
//   addGalleryImage6,
//   addGalleryImage7,
//   addGalleryImage8,
// } from "../../Redux/Actions/CardAction";
import { UploadOutlined } from "@ant-design/icons";
// import { CardContext } from "../../store/CardContext";


const App = () => {
  // const dispatch = useDispatch();
  // const {
  //   highlightPhotos1,
  //   highlightPhotos2,
  //   highlightPhotos3,
  //   highlightPhotos4,
  // } = useSelector((state) => state.cardReducer);

  // const [fileList1, setFileList1] = useState(
  //   highlightPhotos1[0]?.thumbUrl
  //     ? [
  //       {
  //         uid: "-1",
  //         name: "image.png",
  //         status: highlightPhotos1[0] ? "done" : "",
  //         url: highlightPhotos1[0] ? highlightPhotos1[0].thumbUrl : "",
  //       },
  //     ]
  //     : []
  // );
  // const [fileList2, setFileList2] = useState(
  //   highlightPhotos2[0]?.thumbUrl
  //     ? [
  //       {
  //         uid: "-1",
  //         name: "image.png",
  //         status: highlightPhotos2[0] ? "done" : "",
  //         url: highlightPhotos2[0] ? highlightPhotos2[0].thumbUrl : "",
  //       },
  //     ]
  //     : []
  // );
  // const [fileList3, setFileList3] = useState(
  //   highlightPhotos3[0]?.thumbUrl
  //     ? [
  //       {
  //         uid: "-1",
  //         name: "image.png",
  //         status: highlightPhotos3[0] ? "done" : "",
  //         url: highlightPhotos3[0] ? highlightPhotos3[0].thumbUrl : "",
  //       },
  //     ]
  //     : []
  // );
  // const [fileList4, setFileList4] = useState(
  //   highlightPhotos4[0]?.thumbUrl
  //     ? [
  //       {
  //         uid: "-1",
  //         name: "image.png",
  //         status: highlightPhotos4[0] ? "done" : "",
  //         url: highlightPhotos4[0] ? highlightPhotos4[0].thumbUrl : "",
  //       },
  //     ]
  //     : []
  // );

  const [fileList1, setFileList1] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [fileList3, setFileList3] = useState([])
  const [fileList4, setFileList4] = useState([])
  const [fileList5, setFileList5] = useState([])
  const [fileList6, setFileList6] = useState([])
  const [fileList7, setFileList7] = useState([])
  const [fileList8, setFileList8] = useState([])
  // const [userData, setUserData] = useContext(CardContext)
  const [userData, setUserData] = useState('')
  

  useEffect(() => {
    // console.log(userData,'^^^^^^^^^^^^^^^^^^^^^^');
    setFileList1(
      userData?.highlightPhotos?.highlightPhotos1
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos1 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos1,
          },
        ]
      : []
    )
    setFileList2(
      userData?.highlightPhotos?.highlightPhotos2
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos2 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos2,
          },
        ]
      : []
    )
    setFileList3(
      userData?.highlightPhotos?.highlightPhotos3
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos3 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos3,
          },
        ]
      : []
    )
    setFileList4(
      userData?.highlightPhotos?.highlightPhotos4
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos4 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos4,
          },
        ]
      : []
    )
    setFileList5(
      userData?.highlightPhotos?.highlightPhotos5
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos5 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos5,
          },
        ]
      : []
    )
    setFileList6(
      userData?.highlightPhotos?.highlightPhotos6
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos6 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos6,
          },
        ]
      : []
    )
    setFileList7(
      userData?.highlightPhotos?.highlightPhotos7
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos7 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos7,
          },
        ]
      : []
    )
    setFileList8(
      userData?.highlightPhotos?.highlightPhotos8
      ? [
          {
            uid: "-1",
            name: "image.png",
            status:  userData.highlightPhotos.highlightPhotos8 ? "done" : "",
            url:  userData.highlightPhotos.highlightPhotos8,
          },
        ]
      : []
    )
  }, [userData])

  const onChange1 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList1(newFileList);

    // dispatch(addGalleryImage1(fileList1));
  };

  const onChange2 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList2(newFileList);

    // dispatch(addGalleryImage2(fileList2));
  };
  const onChange3 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList3(newFileList);

    // dispatch(addGalleryImage3(fileList3));
  };
  const onChange4 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList4(newFileList);

    // dispatch(addGalleryImage4(fileList4));
  };
  const onChange5 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList5(newFileList);

    // dispatch(addGalleryImage5(fileList5));
  };
  const onChange6 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList6(newFileList);

    // dispatch(addGalleryImage6(fileList6));
  };
  const onChange7 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList7(newFileList);

    // dispatch(addGalleryImage7(fileList7));
  };

  const onChange8 = ({ fileList: newFileList }) => {
    if(newFileList[0]?.status){newFileList[0].status="done";}
    setFileList8(newFileList);

    // dispatch(addGalleryImage8(fileList8));
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <>
      <div className="w-[400px]">
        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset > */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList1}
            onChange={onChange1}
            onPreview={onPreview}
            style={{ width: '100px' }}
          >
            {fileList1[0] ? (
              ""
            ) : (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            )}
          </Upload>
        {/* </ImgCrop> */}

        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList2}
            onChange={onChange2}
            onPreview={onPreview}
          >
            {fileList2[0] ? (
              ""
            ) : fileList1[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}

        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList3}
            onChange={onChange3}
            onPreview={onPreview}
          >
            {fileList3[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}

        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList4}
            onChange={onChange4}
            onPreview={onPreview}
          >
            {fileList4[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] && fileList3[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}
        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList5}
            onChange={onChange5}
            onPreview={onPreview}
          >
            {fileList5[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] && fileList3[0]&& fileList4[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}
        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList6}
            onChange={onChange6}
            onPreview={onPreview}
          >
            {fileList6[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] && fileList3[0] && fileList4[0] && fileList5[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}
        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList7}
            onChange={onChange7}
            onPreview={onPreview}
          >
            {fileList7[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] && fileList3[0] && fileList4[0] && fileList5[0] && fileList6[0]  ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}
        {/* <ImgCrop aspect={16 / 9} aspectSlider showReset> */}
          <Upload
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            listType="picture"
            fileList={fileList8}
            onChange={onChange8}
            onPreview={onPreview}
          >
            {fileList8[0] ? (
              ""
            ) : fileList1[0] && fileList2[0] && fileList3[0] && fileList4[0] && fileList5[0] && fileList6[0] && fileList7[0] ? (
              <Button className="mt-5" icon={<UploadOutlined />}>Upload</Button>
            ) : (
              ""
            )}
          </Upload>
        {/* </ImgCrop> */}
      </div>
    </>
  );
};
export default App;
